module.exports = __webpack_public_path__ + "logo.png?0a6bebbd1104d71aa336546401648a56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 19
// module chunks = 0